import React from 'react';
import { Link } from 'react-router-dom';
import './Home.scss';

function Home() {
  return (
    <div className="home">
      <section className="home__hero">
        <h1>Welcome to Health Query</h1>
        <p>Get quick answers to your health-related questions!</p>
        <div className="home__cta">
          <Link to="/register" className="home__button home__button--primary">
            Get Started
          </Link>
          <Link to="/login" className="home__button home__button--secondary">
            Sign In
          </Link>
        </div>
      </section>

      <section className="home__features">
        <h2>Why Choose Health Query?</h2>
        <div className="home__features-grid">
          <div className="home__feature">
            <h3>Quick Answers</h3>
            <p>Get responses to your health questions promptly</p>
          </div>
          <div className="home__feature">
            <h3>Professional Support</h3>
            <p>Connect with qualified healthcare professionals</p>
          </div>
          <div className="home__feature">
            <h3>Secure & Private</h3>
            <p>Your health information is protected and confidential</p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home; 
